import apiService from "./apiService";
import configService from "./configService"; // AGGIUNTO: Import del configService


/**
 * Servizio per la gestione degli ordini
 */
class OrderService {
  /**
   * Ottiene gli ordini standard per un giorno specifico
   * @param {string} day - Nome del giorno (lunedi, martedi, ecc.)
   * @returns {Promise<Array>} Lista degli ordini
   */
  async getOrdineStandard(day) {

    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const destinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/planning/${codcliente}/${destinazione}`;

      const response = await apiService(url, "GET");
      return response.data; 
      
    } catch (error) {
        console.error(`Errore nel recupero dell'ordine standard per ${day}:`, error);
        throw error;
    }
  }

  /**
   * Ottiene gli ordini straordinari e li filtra per una data specifica
   * @param {string} date - Data precisa in formato ISO (es. "2025-06-06")
   * @returns {Promise<Array>} Lista degli ordini filtrati per data
   */
  async getOrdineExtra(date) {
    try {

      const codcliente = localStorage.getItem("codiceCliente");
      const destinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/straordinari/${codcliente}/${destinazione}`;

      const response = await apiService(url, "GET");
      const allOrders = response.data;

      // Se la data non è fornita, restituisci tutti gli ordini
      if (!date) {
        console.log("Data non fornita, restituisco tutti gli ordini.");
        return allOrders;
      }
  
      // Filtra gli ordini per la data specifica
      const filteredOrders = allOrders.filter((order) => order.data_ord === date);
      return filteredOrders;
    } catch (error) {
      console.error(`Errore nel recupero degli ordini straordinari per ${date}:`, error);
      throw error;
    }
  }

  /**
   * Ottiene la lista degli articoli disponibili
   * @returns {Promise<Array>} Lista degli articoli
   */
  async getListaArticoli() {
    try {
     
      const codcliente = localStorage.getItem("codiceCliente");
      const url = `/applicazioni/panificatori/${codcliente}/articoli`;

      const response = await apiService(url, "GET");

      return response.data; 
    } catch (error) {
      console.error(`Errore nel recupero della lista prodotti`, error);
        throw error;
    }
  }


  async getCategorieArticoli() {
    try {
    
      const selettoreGruppo = await configService.getSelettoreGruppo();
      if  (selettoreGruppo == 0 || selettoreGruppo == null) {
        selettoreGruppo = 1;
      }


      const url = `/applicazioni/panificatori/categorie/${selettoreGruppo}`;
      const response = await apiService(url, "GET");
      return response.data; 
    } catch (error) {
      console.error(`Errore nel recupero delle categorie articoli`, error);
        throw error;
    }
  }


  /**
   * Salva gli articoli per il planning settimanale
   * @param {Array} articoli - Lista degli articoli da salvare
   * @returns {Promise<Object>} Risposta dal server
   */

  async salvaPlanning(articoli, varelimina_non_presenti = false) {
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/planning/${codcliente}/${coddestinazione}`;

      const body = {
        'elimina_non_presenti': varelimina_non_presenti,
        articoli,
      };

      console.log("Body della richiesta:", body);

      // Verifica se il token è present
      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nel salvataggio degli articoli:", error);
      throw error;
    }
  }

  async eliminaPlanning(articoli) {
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/planning/${codcliente}/${coddestinazione}`;

      const body = {
        "arti_da_cancellare": [articoli]
      };

      const response = await apiService(url, "DELETE", body);
      return response.data;
    } catch (error) {
      console.error("Errore nel salvataggio degli articoli:", error);
      throw error;
    }
  }



  async salvaExtra(ordini, varelimina_non_presenti = false) {
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/straordinari/${codcliente}/${coddestinazione}/apertura`;

      const body = {
        'elimina_non_presenti': varelimina_non_presenti,
        ordini,
      };

      // Verifica se il token è present
      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nel salvataggio degli articoli:", error);
      throw error;
    }
  }


  async chiusuraExtra(arrayDate) {
     
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/straordinari/${codcliente}/${coddestinazione}/chiusura`;

      // Costruisci il body con l'array di date
      const body = {
        date_chiusura: arrayDate, // Array di date per la chiusura
      };

      // Verifica se il token è present
      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nel salvataggio degli articoli:", error);
      throw error;
    }
  }

  async eliminaExtra(arrayDate) {
     
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/straordinari/${codcliente}/${coddestinazione}`;

      // Costruisci il body con l'array di date
      const body = {
        date_da_cancellare: arrayDate, // Array di date per la chiusura
      };

      // Verifica se il token è present
      const response = await apiService(url, "DELETE", body);
      return response.data;
    } catch (error) {
      console.error("Errore nell'eliminazione degli ordini straordinari:", error);
      throw error;
    }
  }

  async disabilitaGiorno(giorno, toggle = false) {
    try {
      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const url = `/applicazioni/panificatori/planning/${codcliente}/${coddestinazione}/toggle-day`;

      // Costruisci il body con il giorno e lo stato di attivazione
      const body = {
        'giorno': giorno, // Nome del giorno (lunedi, martedi, ecc.)
        'active': !toggle // Booleano per abilitare/disabilitare il giorno (inverso del toggle)
      };

      // Verifica se il token è present
      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nel settaggio della disattivazione giorno:", error);
      throw error;
    }
  }


  /**
   * Modifica la quantità di un articolo nell'ordine standard
   * @param {string} day - Nome del giorno (lunedi, martedi, ecc.)
   * @param {string} articleId - ID dell'articolo
   * @param {number} quantity - Nuova quantità
   * @returns {Promise<Object>} Risposta dal server
   */
  async modificaQuantita(day, articleId, quantity) {
    try {
      console.log('🔄 === MODIFICA QUANTITA ORDINE ===');
      console.log('📅 Day:', day);
      console.log('🏷️ Article ID:', articleId);
      console.log('🔢 Quantity:', quantity);

      const url = `/api/orders/standard/${day}/article/${articleId}`;
      const body =  quantity;
      
      console.log('📡 URL chiamata:', url);
      console.log('📦 Body inviato:', body);
      
      const response = await apiService(url, "PUT", body);
      
      console.log('✅ Risposta modifica quantità:', response);
      
      /*
      const token = getStorageItem("apiToken");
      if (!token) {
        throw new Error("Token non disponibile");
      }

      const response = await axios.put(`/api/orders/standard/${day}/article/${articleId}`, 
        { quantity },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      );
      */

      return response.data;
    } catch (error) {
      console.error('💥 === ERRORE MODIFICA QUANTITA ===');
      console.error('❌ Errore completo:', error);
      console.error('📜 Stack trace:', error.stack);
      console.error('🌐 Response error:', error.response?.data);
      console.error('📊 Status code:', error.response?.status);
      console.error('📋 Parametri che hanno causato errore:', { day, articleId, quantity });
      
      console.error(`Errore nella modifica della quantità per ${articleId}:`, error);
      throw error;
    }
  }


  async getDDT(evaso = false) {
    try {

      const codcliente = localStorage.getItem("codiceCliente");
      const coddestinazione = localStorage.getItem("codiceDestinazione");
      const mastroClienti = await configService.getMastroCclienti();
      
      
      // Determina l'endpoint in base al parametro evaso
      const endpoint = evaso ? 'documenti/evasi' : 'documenti';
      const filtrodestinazione = (mastroClienti || '14') + String(codcliente) + String(coddestinazione)


      const url = `/${endpoint}?d_nome=${filtrodestinazione}&ttipodocu=3`;
      
      const response = await apiService(url, "GET");

      // Adatta questa riga alla struttura reale della risposta!
      const filteredDDT = Array.isArray(response)
        ? response
        : response.data || response.ddtList || [];

      //const filteredDDT = allDDT.filter(
      //  (DDT) => DDT.d_nome === (mastroClienti || '14') + String(codcliente) + String(coddestinazione)
      //);

      return filteredDDT;
    } catch (error) {
      console.error(`Errore nel recupero delle categorie articoli`, error);
        throw error;
    }
  }

  /**
   * Crea l'anteprima di un blocco di documenti
   * @param {string} bloccoDoc - Codice del blocco di documenti da stampare
   * @param {boolean} evaso - Indica se il documento è evaso (default: false)
   * @returns {Promise<string>} URL dell'anteprima del documento
   */


  async creaAnteprima(bloccoDoc, evaso = false) {
    try {
      const endpoint = evaso ? 'documenti/stampa/evaso' : 'documenti/stampa';
      const url = `/${endpoint}/${bloccoDoc}`;

      // Richiedi il blob direttamente
      const blobData = await apiService(url, "GET", null, { responseType: 'blob' });
      
      // Crea un URL temporaneo per il blob
      const fileURL = URL.createObjectURL(blobData);
      
      // Apre il PDF in una nuova tab
      window.open(fileURL, '_blank');

      return fileURL;
    } catch (error) {
      console.error(`Errore nella creazione dell'anteprima:`, error);
      throw error;
    }
  }


  
  async getAnteprima(pathFileAnteprima) {
    // Se è già un blob URL (nuovo metodo), ritornalo direttamente
    if (pathFileAnteprima && typeof pathFileAnteprima === 'string' && pathFileAnteprima.startsWith('blob:')) {
      return pathFileAnteprima;
    }
    
    // Vecchio metodo: Usa URL relativo per passare attraverso il proxy multi-tenant
    return `/printDocuments/${pathFileAnteprima}`;
  }


  /**
   * Invia una richiesta di iscrizione panificatore
   * @param {Object} datiAzienda - Dati dell'azienda da iscrivere
   * @returns {Promise<Object>} Risposta dal server
   */
  async richiestaIscrizionePanificatore(datiAzienda) {
    try {
      const url = `/applicazioni/panificatori/richiesta-iscrizione`;

       // Costruisci il body con l'array di date
      const body = datiAzienda;

      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nella richiesta di iscrizione panificatore:", error);
      throw error;
    }
  }


  /**
   * Invia una richiesta di iscrizione panificatore
   * @param {Object} datiCredenziali - Dati dell'azienda da iscrivere
   * @returns {Promise<Object>} Risposta dal server
   */
  async invioCredenzialiCliente(datiCredenziali) {
    try {
      const url = `/applicazioni/panificatori/invio-credenziali`;

       // Costruisci il body con i dati credenziali
      const body = datiCredenziali;

      const response = await apiService(url, "POST", body);
      return response.data;
    } catch (error) {
      console.error("Errore nell'invio delle credenziali cliente:", error);
      throw error;
    }
  }
}


const orderServiceInstance = new OrderService();
export default orderServiceInstance;